import { render, staticRenderFns } from "./auditUserManage.vue?vue&type=template&id=cf71456a&scoped=true"
import script from "./auditUserManage.vue?vue&type=script&lang=js"
export * from "./auditUserManage.vue?vue&type=script&lang=js"
import style0 from "./auditUserManage.vue?vue&type=style&index=0&id=cf71456a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf71456a",
  null
  
)

export default component.exports